import { Type } from "@angular/core";
import { ApplicationItemCodeEnum } from "@Portal/Core/Services/AccountService/ApplicationItemCodeEnum";

export type LoaderConfig = {
    state: string;
    applicationList: ApplicationItemCodeEnum[];
    loadModule(): Promise<Type<unknown>>;
};

export const LOADER_CONFIG_LIST: LoaderConfig[] = [
    {
        state: "AR",
        applicationList: [
            ApplicationItemCodeEnum.AR_EVR,
        ],
        loadModule: () => import("@Processors/AR/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "CA",
        applicationList: [
            ApplicationItemCodeEnum.CA_BPEVR,
        ],
        loadModule: () => import("@Processors/CA/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "CO",
        applicationList: [
            ApplicationItemCodeEnum.CO_EVR,
            ApplicationItemCodeEnum.CO_MVR,
        ],
        loadModule: () => import("@Processors/CO/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "FL",
        applicationList: [
            ApplicationItemCodeEnum.FL_EVR,
        ],
        loadModule: () => import("@Processors/FL/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "GA",
        applicationList: [
            ApplicationItemCodeEnum.GA_RTS,
        ],
        loadModule: () => import("@Processors/GA/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "ID",
        applicationList: [
            ApplicationItemCodeEnum.ID_EVR,
            ApplicationItemCodeEnum.ID_MVR,
            ApplicationItemCodeEnum.ID_NTX_EVR,
        ],
        loadModule: () => import("@Processors/ID/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "IL",
        applicationList: [
            ApplicationItemCodeEnum.IL_ERT,
            ApplicationItemCodeEnum.IL_MVR,
        ],
        loadModule: () => import("@Processors/IL/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "IN",
        applicationList: [
            ApplicationItemCodeEnum.IN_REG,
            ApplicationItemCodeEnum.IN_TITLE,
            ApplicationItemCodeEnum.IN_MVR,
        ],
        loadModule: () => import("@Processors/IN/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "KY",
        applicationList: [
            ApplicationItemCodeEnum.KY_EVR,
            ApplicationItemCodeEnum.KY_MVR,
        ],
        loadModule: () => import("@Processors/KY/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "MA",
        applicationList: [
            ApplicationItemCodeEnum.MA_EVR,
            ApplicationItemCodeEnum.MA_RTS,
        ],
        loadModule: () => import("@Processors/MA/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "MD",
        applicationList: [
            ApplicationItemCodeEnum.MD_EVR,
            ApplicationItemCodeEnum.MD_TEMPTAG,
            ApplicationItemCodeEnum.MD_MVR,
        ],
        loadModule: () => import("@Processors/MD/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "MI",
        applicationList: [
            ApplicationItemCodeEnum.MI_EVR,
        ],
        loadModule: () => import("@Processors/MI/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "MN",
        applicationList: [
            ApplicationItemCodeEnum.MN_EVR,
            ApplicationItemCodeEnum.MN_MVR,
        ],
        loadModule: () => import("@Processors/MN/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "MT",
        applicationList: [
            ApplicationItemCodeEnum.MT_EVR,
            ApplicationItemCodeEnum.MT_DTO,
            ApplicationItemCodeEnum.MT_RPLC,
            ApplicationItemCodeEnum.MT_NTX_DTO,
            ApplicationItemCodeEnum.MT_NTX_RPLC,
        ],
        loadModule: () => import("@Processors/MT/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "NC",
        applicationList: [
            ApplicationItemCodeEnum.NC_EVR,
        ],
        loadModule: () => import("@Processors/NC/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "OR",
        applicationList: [
            ApplicationItemCodeEnum.OR_EVR,
            ApplicationItemCodeEnum.OR_MVR,
        ],
        loadModule: () => import("@Processors/OR/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "PA",
        applicationList: [
            ApplicationItemCodeEnum.PA_EVR,
            ApplicationItemCodeEnum.PA_MVR,
        ],
        loadModule: () => import("@Processors/PA/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "SC",
        applicationList: [
            ApplicationItemCodeEnum.SC_EVR,
            // ApplicationItemCodeEnum.SC_MVR,
        ],
        loadModule: () => import("@Processors/SC/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "TX",
        applicationList: [
            ApplicationItemCodeEnum.TX_EVR,
            ApplicationItemCodeEnum.TX_MVR,
        ],
        loadModule: () => import("@Processors/TX/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "VA",
        applicationList: [
            ApplicationItemCodeEnum.VA_EVR,
            ApplicationItemCodeEnum.VA_TEMP_TAG,
            ApplicationItemCodeEnum.VA_MVR,
        ],
        loadModule: () => import("@Processors/VA/module").then(moduleFile => moduleFile.Module),
    },
    {
        state: "WI",
        applicationList: [
            ApplicationItemCodeEnum.WI_EVR,
            ApplicationItemCodeEnum.WI_MVR,
        ],
        loadModule: () => import("@Processors/WI/module").then(moduleFile => moduleFile.Module),
    },
];
